
import React, { Fragment } from "react";
import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../AbstractElements";
import { Col } from "react-bootstrap";
import TestHome from './TestHome';


export default function TestList() {
    return (
        <Fragment>
            <Breadcrumbs mainTitle="List of Test Reports" parent="Home" title="List of Test Reports" />
            <Container fluid={true}>
                <Row>
                    <Col className="h-100">
                        <TestHome />
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}
